function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 5 5"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5 5C2 5 0 3 0 0v5h5z",
    fill: props.color || 'black'
  }));
}
export default SvgCorner;